import { Component, Injector, OnInit } from '@angular/core';
import '@angular/localize/init';
import { ComponentBase } from '@abstracts/component-base';
import { ActivatedRoute, Router } from '@angular/router';
import { TableFunctionsService } from '@services/table/table-functions.service';
import { RouteDataService } from '@services/route-data/route-data.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent extends ComponentBase implements OnInit {

  public className = 'UsersComponent';

  public activeTab = 'users';
  public showAll = true;
  public routerSubscription: Subscription;

  public activeComponentClassName: string;

  public links = [
    { title: $localize`:@@UsersTitel1:Benutzer`, route: 'users' }
  ]

  constructor(
    public tableFunctions: TableFunctionsService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    private routeDataService: RouteDataService,
    injector: Injector
  ) { super(injector); }

  ngOnInit(): void {
    super.ngOnInit();
    this.routeDataService.params = this.activatedRoute.snapshot.params;
  }

  public onRouterOutletActivate(event: any) {
    this.activeComponentClassName = event.className;
  }

}